import {ModalWithNewForm, EitjeButton, Layout, Text} from '~/components'
import {Admin} from '@eitje/api'

export const ManageAdmins = () => {
	return (
		<ModalWithNewForm
			name="manage_admins"
			modalProps={{
				okButtonProps: {
					t: 'common.save',
					leftIcon: 'checked',
				},
				hideSubmit: true,
				hideCancel: true,
				buttons: [<EitjeButton iconLeft="plus" t="common.new" modalLink="/settings/admins/new" />],
			}}
			width={350}
		>
			<AdminUsers />
		</ModalWithNewForm>
	)
}

const AdminUsers = () => {
	const admins = Admin.useDoIndex()

	return (
		<Layout gap={0} direction="vertical" maxHeight={284}>
			{admins.map(admin => (
				<Layout
					key={admin.id}
					horizontal="spaceBetween"
					modalLink={`/settings/admins/${admin.id}/edit`}
					padding={12}
					height={44}
					borderBottom
					colorSet
				>
					<Text semiBold>{admin.name}</Text>
					<Text>{`(${admin.role})`}</Text>
				</Layout>
			))}
		</Layout>
	)
}
